/**
 * Generic Abstract Dialog for attaching images
 */
hrd.dashlets.AbstractImageAttachmentDialog = hrd.dashlets.AbstractAttachmentDialog.extend({
	init: function(parentFormInstance, options) {
		var defaults = {
			impl: 'hrd.dashlets.AbstractImageAttachmentDialog',
			title: xlate('common.attachment.image.dialog.title'),
			dragMessage: xlate('common.attachment.image.dialog.dragZone'),
			basicIcon: 'far fa-image',
			customizeValidation: true,
			supportedExtensions: ['gif', 'png', 'jpg', 'jpeg']
		};
		this._super(parentFormInstance, $.extend({}, defaults, options));
		this.toolbox = new hrd.Toolbox();
	},
	attachmentUploadValidation: function(fileInfo) {
		const maxSizeInfo = fileInfo.maxSizeValidationInfo;
		let acceptedRE = new RegExp(`(\\.|\/)(${this.settings.supportedExtensions.join('|')})$`, 'i');

		return {
			acceptFileTypes: acceptedRE,
			maxFileSize: maxSizeInfo.maxFileSizeInBytes,
			messages: {
				acceptFileTypes: xlate('common.validation.file.notSupportedType.msg', { types: this.settings.supportedExtensions.join(', ') }),
				maxFileSize: xlate('common.validation.file.fileTooLarge.msg', { maxFileSize: maxSizeInfo.maxSize.toFixed(2), sizeUnit: maxSizeInfo.sizeUnit })
			}
		};
	}
});